import React, { FC } from 'react';

import CalendarToday from '@material-ui/icons/CalendarToday';
import { DatePicker as MaterialDatePicker } from 'material-ui-pickers';
import moment from 'moment';

import { mask } from './Utils/mask';

interface IProps {
  className?: string;
  disabled?: boolean;
  errorMessage?: string;
  fullWidth?: boolean;
  iconError?: boolean;
  id?: string;
  label: string;
  maxDate?: string;
  minDate?: string;
  minDateMessage?: string;
  noKeyboard?: boolean;
  onChange?: any;
  onError?: any;
  placeholder?: string;
  value?: string;
}

const DatePicker: FC<IProps> = props => {
  const {
    className,
    fullWidth,
    iconError,
    id,
    label,
    maxDate,
    minDate,
    minDateMessage,
    noKeyboard,
    onChange,
    onError,
    placeholder,
    disabled,
    value
  } = props;

  const formattedValueDate = moment(value).format('MM/DD/YYYY');

  return (
    <MaterialDatePicker
      animateYearScrolling={false}
      autoOk={true}
      className={`datepicker override ${className} ${disabled ? 'disabled' : ''}`}
      DialogProps={{ className: 'datepicker-dialog override' }}
      disabled={disabled}
      disableOpenOnEnter={true}
      format="MM/DD/YYYY"
      fullWidth={fullWidth}
      id={id}
      keyboard={!noKeyboard}
      keyboardIcon={
        <CalendarToday
          color={
            iconError ||
            ((value !== '' && value === 'Invalid date') || value === 'Invalid date'
              ? !moment(formattedValueDate, 'MM/DD/YYYY', true).isValid()
              : false)
              ? 'error'
              : 'primary'
          }
          {...{ className: 'date-picker-icon' }}
        />
      }
      label={label}
      mask={mask}
      maxDate={maxDate}
      minDate={minDate}
      minDateMessage={minDateMessage}
      onChange={onChange}
      onError={onError}
      placeholder={placeholder}
      value={value}
    />
  );
};

export default DatePicker;
